import { Grid } from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Image } from "react-image-and-background-image-fade"
import kim_dental_logo from "../../images/kim-dental-logo.png"
import good_health from "../../images/good-health-and-well-being.png"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const StyledLogoWrapper = styled.div`
  width: 40%;
  margin-bottom: 5%;

  ${breakpoint.sm} {
    width: 35%;
  }
  ${breakpoint.md} {
    width: 30%;
  }
`

const StyledInvestmentThemeWrapper = styled.div`
  width: 100%;
  border-bottom: 2px solid #0f6494;
  padding-top: 8px;
  padding-bottom: 8px;

  ${breakpoint.lg} {
    border-bottom: 3px solid #0f6494;
    padding-top: 12px;
    padding-bottom: 12px;
  }
`

const KimDentalMapDetailMobile = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <StyledLogoWrapper>
            <Image
              src={kim_dental_logo}
              width="532px"
              height="370px"
              isResponsive
              disableLoader
              alt="kim dental"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </StyledLogoWrapper>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div style={{ marginBottom: "1%" }}>
          <StyledDetailHeader>Oral Healthcare</StyledDetailHeader>
        </div>
      </Grid>
      <Grid item xs={12}>
        <StyledDetailLocation>Based in Vietnam</StyledDetailLocation>
      </Grid>
      <Grid container>
        <Grid item xs={12} container alignItems="center">
          <StyledInvestmentThemeWrapper>
            <Grid item xs={12}>
              <div style={{ marginBottom: "1%" }}>
                <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
              </div>
            </Grid>
            <Grid item xs={12}>
              <StyledDetailSubheaderContent>
                Better Healthcare & Education
              </StyledDetailSubheaderContent>
            </Grid>
          </StyledInvestmentThemeWrapper>
        </Grid>
        <Grid item xs={12}>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            About the Company
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Dental service provider operating a network of 19 clinics across six
            cities in Vietnam.
          </StyledDetailSubheaderContent>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            Impact Thesis
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Enhancing access to oral healthcare services and prevention efforts
            in Vietnam to reduce the risks of oral and non-communicable
            diseases.
          </StyledDetailSubheaderContent>
        </Grid>
      </Grid>
      <div style={{ width: "100%", marginTop: "10%" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Image
              src={good_health}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="life on land"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default KimDentalMapDetailMobile
